
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import SaleMenuScheduleAddEdit from '@/views/DashView/SaleMenuSchedule/SaleMenuScheduleAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class SaleMenuScheduleItem {
  id: string = '';
  outletCode: string = '';
  menuItemCode: string = '';
  status: string = '';
  beginDate: number = 10000101;
  endDate: number = 99991231;
  beginDay: number = 0;
  endDay: number = 0;
  beginHour: number = 0;
  endHour: number = 0;
}

@Component({
  components: {
    editor: SaleMenuScheduleAddEdit
  }
})
export default class SaleMenuScheduleList extends RemoteDataTable<
  SaleMenuScheduleItem
  > {
  public pageTitle: string = 'Sale Menu Schedule List';

  public newButtonText: string = 'New Sale Menu Schedule';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),

    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'menuItemCode', label: 'Menu Item Code' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({ key: 'beginDate', label: 'Begin Date' }),
    new RemoteDataField({ key: 'endDate', label: 'End Date' }),
    new RemoteDataField({ key: 'beginDay', label: 'Begin Day' }),
    new RemoteDataField({ key: 'endDay', label: 'End Day' }),
    new RemoteDataField({ key: 'beginHour', label: 'Begin Hour' }),
    new RemoteDataField({ key: 'endHour', label: 'End Hour' })
  ];

  // to get page data
  get items(): SaleMenuScheduleItem[] {
    return this.$store.getters.GetAllSaleMenuSchedule;
  }

  get paging(): SaleMenuScheduleItem[] {
    return this.$store.getters.PagingSaleMenuSchedule;
  }

  get sorting(): SaleMenuScheduleItem[] {
    return this.$store.getters.SortingSaleMenuSchedule;
  }

  get filtering(): SaleMenuScheduleItem[] {
    return this.$store.getters.FilteringSaleMenuSchedule;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingSaleMenuSchedule', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringSaleMenuSchedule', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.saleMenuSchedule.pagingSaleMenuSchedule.page = 1;
    }
    this.$store.dispatch('GetAllSaleMenuSchedule');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteSaleMenuSchedule', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }
  mounted() {
    this.reload();
  }
  setPerPage(page) {
    this.$store.state.saleMenuSchedule.pagingSaleMenuSchedule.size = page;
    this.$store.dispatch('GetAllSaleMenuSchedule');
  }
}
